module.exports = __webpack_public_path__ + "static/media/notice.3e28c2d6.svg";